const values = (options) => options?.map((option) => option.value)

/**
 * Le corps de `updateStudentAccount` envoyé par l'ancien formulaire « Paramètres »
 * (`SettingsTabNavigator`) : ses quatre onglets, enregistrés d'un seul bouton.
 *
 * `dirtyFields` (react-hook-form) dit les champs que l'élève a touchés. La classe part
 * toujours, mais elle ne s'affirme (`affirm_class`) que si l'élève a touché le champ
 * Classe : un réglage enregistré depuis un autre onglet ne répond pas à sa place.
 */
export function toLegacyStudentAccountBody(data, dirtyFields = {}) {
    return {
        firstname: data.firstname,
        lastname: data.lastname,
        email: data.email,
        mobile: data.mobile,
        parent_firstname: data.parent_firstname,
        parent_lastname: data.parent_lastname,
        parent_email: data.parent_email,
        parent_mobile: data.parent_mobile,
        school_name: data.school_name,
        city: data.city,
        street: data.street,
        complement: data.complement,
        postal_code: data.postal_code,
        country: data.country?.value ?? "FR",
        class: data.class?.value,
        affirm_class: !!dirtyFields.class,
        reason: data.reason?.value,
        subject_priority: data.subject_priority?.value,
        future_orientation: data.future_orientation,
        future_job: data.future_job,
        personal_work_frequency: data.personal_work_frequency?.value,
        personal_work_duration: data.personal_work_duration?.value,
        qualities: values(data.qualities),
        specialty_school_subjects: values(data.specialty_school_subjects),
        prioritized_school_subjects: values(data.prioritized_school_subjects),
        appreciated_school_subjects: values(data.appreciated_school_subjects),
        notification_settings: data.notification_settings,
        interests: data.interests?.value,
    }
}
